/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Certificate status
 */
export type UpdateFursSettings200CertificateStatus = typeof UpdateFursSettings200CertificateStatus[keyof typeof UpdateFursSettings200CertificateStatus];


export const UpdateFursSettings200CertificateStatus = {
  valid: 'valid',
  expiring_soon: 'expiring_soon',
  expired: 'expired',
  missing: 'missing',
} as const;
